import React, { useEffect, useMemo, useState } from 'react';
import SubscriptionsHeader from '../features/Subscriptions/components/SubscriptionsHeader';
import SubscriptionsTable from '../features/Subscriptions/components/SubscriptionsTable';
import { useSubscriptionsStore } from '../features/Subscriptions/store/subscriptions';
import { usePackagesStore } from '../features/Packages/store/packagesStore';
import * as XLSX from 'xlsx';
import ExportSubscriptionsModal from '../features/Subscriptions/components/modals/ExportSubscriptions';
import { PuffLoader } from 'react-spinners';

const SubscriptionsContent: React.FC = () => {
    const [activeTab, setActiveTab] = useState('All');
    const [selectedService, setSelectedService] = useState('All');
    const { subscriptions, fetchSubscriptions } = useSubscriptionsStore();
    const { packages } = usePackagesStore();
    const [selectedPackage, setSelectedPackage] = useState("All");
    const [searchTerm, setSearchTerm] = React.useState('');
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadSubscriptions = async () => {
            if (subscriptions.length === 0) {
                setLoading(true);
                await fetchSubscriptions();
                setLoading(false);
            }
        };

        loadSubscriptions();
    }, [subscriptions, fetchSubscriptions]);


    const filteredSubscriptions = useMemo(() => {
        return subscriptions.filter(sub => {
            // Always show if both filters are 'All'
            // if (activeTab === 'All' && selectedService === 'All' && selectedPackage === 'All') {
            //     return true;
            // }

            const serviceMatch =
                selectedService === 'All' ||
                sub.service_name.toLowerCase() === selectedService.toLowerCase();

            const searchMatch =
                searchTerm === '' ||
                sub.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                sub.userid?.toLowerCase().includes(searchTerm.toLowerCase());

            // Filter by status if not 'All'
            const statusMatch = activeTab === 'All' || sub.status === activeTab;

            // Filter by service if not 'All'
            // const serviceMatch = selectedService === 'All' ||
            //     sub.service_name.toLowerCase() === selectedService.toLowerCase();

            // Filter by package if not 'All'
            const packageMatch = selectedPackage === 'All' ||
                sub.package_name.toLowerCase() === selectedPackage.toLowerCase();

            return statusMatch && serviceMatch && packageMatch && searchMatch;
        });
    }, [activeTab, selectedService, selectedPackage, searchTerm, subscriptions]);

    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();

        const ws = XLSX.utils.json_to_sheet(filteredSubscriptions.map(sub => ({
            'User ID': sub.userid,
            'Username': sub.username,
            'Package': sub.package_name,
            'Service': sub.service_name,
            'Status': sub.status,
            'Amount': sub.price,
            'Start Date': sub.created_at,
            'Renewal Date': sub.renewed_at || 'N/A'
        })));

        XLSX.utils.book_append_sheet(wb, ws, 'Subscriptions');
        XLSX.writeFile(wb, `subscriptions_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    if (loading) {
        return <div className='w-full flex flex-col items-center justify-center h-full'><PuffLoader color="#FFFFFF" /></div>;
    }

    return (
        <div className='w-full flex flex-col items-start justify-start p-4'>
            <SubscriptionsHeader
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                selectedService={selectedService}
                setSelectedService={setSelectedService}
                packages={packages}
                selectedPackage={selectedPackage}
                setSelectedPackage={setSelectedPackage}
                onExport={() => setIsExportModalOpen(true)}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
            />
            <SubscriptionsTable subscriptions={filteredSubscriptions} />

            <ExportSubscriptionsModal
                isOpen={isExportModalOpen}
                onClose={() => setIsExportModalOpen(false)}
            />
        </div>
    );
};

export default SubscriptionsContent;
